import type { RangyRange } from '../types/rangy';
import convertRangeToRangyRange from './convertRangeToRangyRange';

export default (rangeToCrop: Range, boundaryRange: Range): RangyRange | null =>
  convertRangeToRangyRange(rangeToCrop).intersection(convertRangeToRangyRange(boundaryRange));
